import React from "react";
import regbanner from "../../../assets/images/hdb.png";
import { ProgramDetails } from "../../../pages/Registration";
import styles from "./index.module.css";

interface HeaderProps {
  ProgramDetails?: ProgramDetails;
}
const RegistrationHeader: React.FC<HeaderProps> = ({ ProgramDetails }) => {
  return (
    <>
      {/* Navigation */}

      {/* <div className={styles.navigation}>
        <div className={styles.navContent}>
          <div className={styles.navItems}
              onClick={() => window.history.back()}
            >
            <Button 
              variant="ghost" 
              size="sm" 
              className={styles.backButton}
            >
              <ArrowLeft className={styles.backIcon} />
              <span className={styles.backText}>back</span>
            </Button>
            <span className={styles.pageTitle}>{ProgramDetails?.name} Registration</span>
          </div>
        </div>
      </div> */}
      {/* Banner */}
      <div className={styles.banner}>
        <img
          // src={ProgramDetails?.bannerImageUrl != "" ? ProgramDetails?.bannerImageUrl : regbanner}
          src={
              ProgramDetails?.bannerImageUrl && ProgramDetails?.bannerImageUrl !== ""
              ? ProgramDetails.bannerImageUrl
              : regbanner
          }
          alt="Entrainment'25 Banner"
          className={styles.bannerImage}
        />
        {/* <img 
          src={entrainmentLogo} 
          alt="Entrainment'25 Banner" 
          className={styles.bannerLogo}
        /> */}
        {/* <div className={styles.bannerContent}>
          <div className={styles.bannerText}>
            <h1 className={styles.bannerTitle}>{ProgramDetails.name}</h1>
            <p className={styles.bannerSubtitle}>{ProgramDetails.description}</p>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default RegistrationHeader;
